import React, { useState, useEffect, useMemo } from "react"
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
} from "reactstrap"
import { useDispatch } from "react-redux"
import { markAbsentStud, getAttendReportReset } from "store/actions"

const AbsentPop = ({
  isOpen,
  toggle,
  onConfirm,
  abStudData,
  filteredStudents,
  Adata,
}) => {
  const dispatch = useDispatch()
  const absentUserIds = abStudData?.abStdUserIdsArr || []

  const absentStudents = useMemo(() => {
    return (
      filteredStudents?.filter(student =>
        absentUserIds.includes(String(student.user_id))
      ) || []
    )
  }, [abStudData, filteredStudents])

  const [selectedStudents, setSelectedStudents] = useState([])

  useEffect(() => {
    if (isOpen) {
      setSelectedStudents(absentStudents.map(s => s.user_id))
    }
  }, [isOpen])

  const handleCheckboxChange = id => {
    setSelectedStudents(prev =>
      prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]
    )
  }

  const handleConfirm = () => {
    const data = {
      ...Adata,
      student_list: selectedStudents.map(String),
    }
    dispatch(markAbsentStud({ data }))
    onConfirm(selectedStudents)
    toggle()
    setSelectedStudents([])
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} className="p-0">
      <ModalHeader toggle={toggle}>Absent Students</ModalHeader>
      <ModalBody>
        {absentStudents.length === 0 ? (
          <p>No absent students found.</p>
        ) : (
          absentStudents.map(student => (
            <FormGroup
              key={student.user_id}
              className="d-flex justify-content-between align-items-center border-bottom py-2"
            >
              <Label className="mb-0">{student.name}</Label>
              <Input
                type="checkbox"
                onChange={() => handleCheckboxChange(student.user_id)}
                checked={selectedStudents.includes(student.user_id)}
                style={{ transform: "scale(1.2)" }}
              />
            </FormGroup>
          ))
        )}
      </ModalBody>
      <ModalFooter className="d-flex justify-content-center">
        <Button
          color="danger"
          onClick={handleConfirm}
          disabled={selectedStudents.length === 0}
          className="me-3"
        >
          Mark Absent
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default AbsentPop
